import { CdnService } from '../cdn-service/cdn.service';
import * as i0 from "@angular/core";
import * as i1 from "../cdn-service/cdn.service";
/**
 * Ported over from universa-layout
 */
var CdnBaseService = /** @class */ (function () {
    function CdnBaseService(cdnService) {
        this.cdnService = cdnService;
    }
    CdnBaseService.prototype.getCDNUrl = function (url) {
        if (!this.baseUrl) {
            this.baseUrl = this.getCDNBase();
        }
        if (this.baseUrl !== '/') {
            url = this.baseUrl + this.stripBaseUrl(url);
        }
        return url;
    };
    CdnBaseService.prototype.getCDNBase = function () {
        var base = this.cdnService.getCDNUrl('/');
        var baseArray = base.match(/(https|http):\/\/[a-zA-Z0-9\.\-:]*/g);
        if (baseArray && baseArray.length > 0) {
            base = baseArray[0];
        }
        return base;
    };
    CdnBaseService.prototype.stripBaseUrl = function (url) {
        var newUrl = url.replace(/(https|http):\/\/[a-zA-Z0-9\.\-:]*/g, '').trim();
        return newUrl;
    };
    CdnBaseService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CdnBaseService_Factory() { return new CdnBaseService(i0.ɵɵinject(i1.CdnService)); }, token: CdnBaseService, providedIn: "root" });
    return CdnBaseService;
}());
export { CdnBaseService };
